import React, { FC } from 'react';
import styled from 'styled-components';

import { HeaderLogo } from 'componentsShared/Icons';
import Close from 'assets/images/closeBlack.svg';
import { useAppSelector } from 'redux/store';

type THeaderProps = {
  onClose: () => void;
  isMobile: boolean;
};

export const Header: FC<THeaderProps> = ({ onClose, isMobile }) => {
  const { users, userType } = useAppSelector((state) => state.usersSlice);
  const profile = userType ? users?.[userType] : null;

  return (
    <SLogoWrapper>
      {isMobile ? (
        <SAccountWrapper>
          <SAccount>
            {profile && 'profilePicture' in profile && profile.profilePicture ? (
              <SAvatar src={profile.profilePicture} alt='profile pic' />
            ) : (
              <SAccountSvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
                <path d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z' />
              </SAccountSvg>
            )}
            <SName>{profile?.name}</SName>
          </SAccount>
          <SCloseIcon src={Close} alt='Close' onClick={onClose} />
        </SAccountWrapper>
      ) : (
        <HeaderLogo />
      )}
    </SLogoWrapper>
  );
};

const SLogoWrapper = styled.div`
  margin: 16px 0 28px 32px;
  @media (max-width: 1024px) {
    margin: 0;
    height: 84px;
    padding: 12px 24px;
    max-width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #ffffff;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);
    border-radius: 8px 8px 0px 0px;
  }
`;

const SAccountWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const SAccount = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: calc(100% - 24px);
`;

const SName = styled.h4`
  font-size: 20px;
  font-weight: 500;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  flex: 1;
  margin: 0;
`;

const SAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 16px;
`;

const SAccountSvg = styled.svg`
  width: 40px;
  height: 40px;
  fill: #0d0d0d;
  margin-right: 16px;
  flex-shrink: 0;
`;

const SCloseIcon = styled.img`
  cursor: pointer;
  width: 24px;
  height: 24px;
`;
